/** @prettier */
import * as apiIF from './Type/api';
/**
 * 共通の定数
 */

/**
 * フォーマット関連
 */
export class format {
  /** 一般的な項目の異常判定用正規表現 */
  static readonly BASIC_PATTERN_ERROR = /[^,.!_/'()[\]+=\-$#&@?%*:;A-Za-z0-9 ]/;
  /** S3で推奨されていない文字判定用正規表現
   * 以下のサイトに基づいて禁止文字を設定した
   * ASCIIに関しては多言語入力に影響する可能性があるため制限しない
   * https://docs.aws.amazon.com/ja_jp/AmazonS3/latest/userguide/object-keys.html
   */
  static readonly BASIC_PATTERN_S3_POLICY = /[\\&$@=;/:+ ,?{^}%`\]'">[~<#|]/;
  /** 一般的な項目の最小文字数 */
  static readonly BASIC_LENGTH_MIN = 1;
  /** 一般的な項目の最大文字数 */
  static readonly BASIC_LENGTH_MAX = 32;

  /** メールアドレスの正常判定用正規表現 */
  static readonly EMAIL_PATTERN_OK =
    /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  /** メールアドレスの最小文字数 */
  static readonly EMAIL_LENGTH_MIN = 2;
  /** メールアドレスの最大文字数 */
  static readonly EMAIL_LENGTH_MAX = 100;

  /** パスワードの正常判定用正規表現 */
  static readonly PASSWORD_PATTERN_OK =
    /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]{0,32}$/;
  /** パスワードの最小文字数 */
  static readonly PASSWORD_LENGTH_MIN = 10;
  /** パスワードの最大文字数 */
  static readonly PASSWORD_LENGTH_MAX = 32;

  /** ゲートウェイの名前の最小文字数 */
  static readonly GW_NAME_LENGTH_MIN = 1;
  /** ゲートウェイの名前の最大文字数 */
  static readonly GW_NAME_LENGTH_MAX = 50;

  /** アクティベーションコード(代理店)の文字数 */
  /** TODO:テスト用に12文字としておくが、実際の仕様は8文字 */
  static readonly ACTIVATION_CODE_LENGTH_MAX = 12;

  /** フッターの最小文字数 */
  static readonly FOOTER_LENGTH_MIN = 1;
  /** フッターの最大文字数 */
  static readonly FOOTER_LENGTH_MAX = 100;

  /** 電圧の正常判定用正規表現 */
  static readonly VOLTAGE_PATTERN_OK = /^\d$|^[1-9]\d$|^[1-9]\d\d$/;

  /** IPアドレスの正常判定用正規表現 */
  static readonly IPADDRESS_PATTERN_OK =
    /^(([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])$/;
  /** IPアドレスの最大文字数 */
  static readonly IP_ADDRESS_LENGTH_MAX = 15;
  /** IPアドレスの最小文字数 */
  static readonly IP_ADDRESS_LENGTH_MIN = 7;

  /** CO2排出係数の正常判定用正規表現 */
  static readonly CO2_EMISSION_PATTERN_OK = /^([1-9][0-9]*|0)(\.[0-9]+)?$/;
  /** 納入日の正常判定用正規表現 */
  static readonly INSTALL_DATE_PATTERN_OK =
    /^([0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01]))*$/;

  /** 製造番号の最大文字数 */
  static readonly PERIODIC_REPORT_SETTING_SERIAL_NUMBER_LENGTH_MAX = 30;
  /** 定期レポート設定の電気料金プランの料金名称の最大文字数 */
  static readonly PERIODIC_REPORT_SETTING_ELECTRICITY_UNIT_PRICE_OF_NAME_LENGTH_MAX = 36;
  /** 定期レポート設定の製造番号の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_SERIAL_NUMBER_OK =
    /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]{0,30}$/;
  /** 定期レポート設定のCO2排出係数の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_CO2_EMISSION_PATTERN_OK =
    /^(0)(\.[0-9]{1,3})?$|^(1)(\.0{1,3})?$/;
  /** 定期レポート設定の代替燃料のCO2排出係数の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_ALTERNATIVE_CO2_EMISSION_PATTERN_OK =
    /^(100(\.0{1,3})?|(\d{1,2})(\.\d{1,3})?)?$/;
  /** 定期レポート設定の電気料金通貨の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_CURRENCY_OK = /^[A-Z]{3}$/;
  /** 定期レポート設定の電気料金単価の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_PRICE_RATE_OK =
    /^([1-9][0-9]{0,2})(\.[0-9]{1,2})?$|^(0\.[1-9][0-9]{0,1})?$|^(0\.0[1-9]{1})?$|^1000$/;
  /** 定期レポート設定の代替燃料単価の正常判定正規表現 */
  static readonly PERIODIC_REPORT_SETTING_ALTERNATIVE_FUEL_RATE_OK =
    /^([1-9][0-9]{0,5})(\.[0-9]{1,2})?$|^(0\.[1-9][0-9]{0,1})?$|^(0\.0[1-9]{1})?$|^1000000$/;
  /** 定期レポート設定の代替燃料システム効率の正常判定用正規表現 */
  static readonly PERIODIC_REPORT_SETTING_SYSTEM_EFFICIENCY_OK =
    /^[1-9]$|^[1-9][0-9]$|^100$/;
  /** 室外機の電流制限値設定用正規表現 */
  static readonly CAPACITY_PATTERN_OK = /^\d$|^[1-9]\d$|^100$/;
  /** 一括登録用CSV　室外アドレス(新SL) */
  static readonly NEW_OU_ADDRESS_PATTERN_OK = /^[0-9]$|^[1-2][0-9]$|^3[0-1]$/;
  /** 一括登録用CSV　室外アドレス(旧SL) */
  static readonly OLD_OU_ADDRESS_PATTERN_OK = /^[0-9]$|^[1-3][0-9]$|^4[0-7]$/;
  /** 一括登録用CSV　相数 */
  static readonly POWERSUPPLY_PATTERN_OK = /^threePhase$|^singlePhase$/;
  /** 一括登録用CSV　親子設定(新SL) */
  static readonly NEW_OU_PARENT_PATTERN_OK =
    /^[0-9]$|^[1-2][0-9]$|^3[0-1]$|^None$/;
  /** 一括登録用CSV　親子設定(旧SL) */
  static readonly OLD_OU_PARENT_PATTERN_OK =
    /^[0-9]$|^[1-3][0-9]$|^4[0-7]$|^None$/;
  /** 一括登録用CSV　室内アドレス(新SL) */
  static readonly NEW_IU_ADDRESS_PATTERN_OK =
    /^[0-9]$|^[1-9][0-9]$|^1[0-1][0-9]$|^12[0-7]$/;
  /** 一括登録用CSV　室内アドレス(旧SL) */
  static readonly OLD_IU_ADDRESS_PATTERN_OK = /^[0-9]$|^[1-3][0-9]$|^4[0-7]$/;
  /** 一括登録用CSV　室内機タイプ */
  static readonly IU_TYPE_PATTERN_OK =
    /^AC General$|^4way Cassette$|^2way Cassette$|^1way Cassette$|^Ceiling Suspended$|^Floor Standing$|^Floor Standing Console$|^Wall Mounted$|^Duct Connected$/;
  /** 一括登録用CSV　IFアドレス(新SL) */
  static readonly NEW_IF_ADDRESS_PATTERN_OK =
    /^[0-9]$|^[1-9][0-9]$|^1[0-1][0-9]$|^12[0-7]$/;
  /** 一括登録用CSV　IFアドレス(旧SL) */
  static readonly OLD_IF_ADDRESS_PATTERN_OK = /^[0-9]$|^[1-3][0-9]$|^4[0-7]$/;
  /** 一括登録用CSV　空調機タイプ */
  static readonly IF_UNIT_TYPE_PATTERN_OK =
    /^AC General$|^4way Cassette$|^2way Cassette$|^1way Cassette$|^Ceiling Suspended$|^Floor Standing$|^Floor Standing Console$|^Wall Mounted$|^Duct Connected$|^Lighting$|^Ventilation$/;
  /** 一括登録用CSV　IFタイプ */
  static readonly IF_TYPE_PATTERN_OK = /^SC-ADNA-E$|^other$/;

  /** スケジュール登録用CSV　時間設定 */
  static readonly SCHEDULE_COMMAND_TIME_PATTERN_OK =
    /^(0[0-9]|[0-9]|[1][0-9]|2[0-3]):([0-5][0-9]|[0-9])$/;

  /** スケジュール登録用CSV　運転停止 */
  static readonly SCHEDULE_RUN_STOP_PATTERN_OK = /^on$|^off$|^$/;
  /** スケジュール登録用CSV　運転モード */
  static readonly SCHEDULE_OPERATION_MODE_PATTERN_OK =
    /^auto$|^dry$|^cooling$|^fan$|^heating$|^$/;
  /** スケジュール登録用CSV　設定温度(Heating以外) */
  static readonly SCHEDULE_PRESET_TEMPERATURE_PATTERN_OK =
    /^1[8-9]$|^1[8-9].0$|^1[8-9].5$|^2[0-9]$|^2[0-9].0$|^2[0-9].5$|^30$|^30.0$|^$/;
  /** スケジュール登録用CSV　設定温度(Heating) */
  static readonly SCHEDULE_PRESET_TEMPERATURE_HEATING_PATTERN_OK =
    /^1[6-9]$|^1[6-9].0$|^1[6-9].5$|^2[0-9]$|^2[0-9].0$|^2[0-9].5$|^30$|^30.0$|^$/;
  /** スケジュール登録用CSV　風量 */
  static readonly SCHEDULE_AIR_FLOW_PATTERN_OK =
    /^auto$|^low$|^medium$|^high$|^powerful$|^$/;
}

/**
 * 制限関連
 */
export class limit {
  /** 1ユーザで登録できる最大サイト数 */
  static readonly REGISTRATION_NUM_SITE_MAX = 128;
  /** 1サイトで登録できる最大ゲートウェイ数 */
  static readonly REGISTRATION_NUM_GW_MAX = 10;
  /** 1サイトで登録できる最大グループ数 */
  static readonly REGISTRATION_NUM_GROUP_MAX = 100;
  /** 1サイトで登録できる最大権限付与数 */
  static readonly REGISTRATION_NUM_AUTHORITY_MAX = 100;
  /** 一度に状態値を表示できる最大グループ数（Modbusのみ） */
  static readonly DISPLAY_NUM_MODBUS_GROUP_MAX = 4;
  /** サービス履歴機能の保存できるテキスト上限(単位:Byte) */
  static readonly SITE_INFO_NUM_SERVICE_HISTORY_TEXT_MAX = 512000;

  /** 新SL 1系統で登録できる最大室外機数 */
  static readonly REGISTRATION_NUM_NEW_SL_OU_MAX = 32;
  /** 旧SL 1系統で登録できる最大室外機数 */
  static readonly REGISTRATION_NUM_OLD_SL_OU_MAX = 48;
  /** 新SL 1系統で登録できる最大室内機数（その他空調機含む） */
  static readonly REGISTRATION_NUM_NEW_SL_IU_MAX = 128;
  /** 旧SL 1系統で登録できる最大室内機数（その他空調機含む） */
  static readonly REGISTRATION_NUM_OLD_SL_IU_MAX = 48;
  /** 1系統で登録できる最大熱源機数 */
  static readonly REGISTRATION_NUM_RT_UNIT_MAX = 16;
  /** 1室外機で登録できる最大RT室内機数 */
  static readonly REGISTRATION_NUM_RT_IU_MAX = 16;
  /** 1ゲートウェイで登録できる最大Modbus室外機数 */
  static readonly REGISTRATION_NUM_MODBUS_OU_MAX = 16;
  /** Modbus室外機に登録できるアドレスの最小値 */
  static readonly MODBUS_OU_ADDRESS_MIN = 0;
  /** Modbus室外機に登録できるアドレスの最大値 */
  static readonly MODBUS_OU_ADDRESS_MAX = 7;
  /** 1室外機で登録できる最大Modbus室内機数 */
  static readonly REGISTRATION_NUM_MODBUS_IU_MAX = 8;
  /** 1グループに所属できる室内機の最大数 */
  static readonly REGISTRATION_NUM_GROUP_IU_MAX = 36;

  /** アップロードファイルの最大サイズ（MB） */
  static readonly UPLOAD_FILE_SIZE_MAX = 500;
  /** ダウンロードファイルの最大サイズ（MB）※Lambdaで処理するファイルのみ */
  static readonly DOWNLOAD_FILE_SIZE_MAX = 500;

  /** レイアウト画像分割数（X軸、Y軸共通） */
  static readonly LAYOUT_SPLIT_NUM = 100;

  /** 庫内温度と設定温度の温度差の警戒レベルを判定するための境界の最小値 */
  static readonly WARNING_THRESHOLDS_MIN = -5;
  /** 庫内温度と設定温度の温度差の警戒レベルを判定するための境界の最大値 */
  static readonly WARNING_THRESHOLDS_MAX = 5;

  /** 庫内温度と設定温度の温度差の警戒レベルを判定するための境界の最小値が許容する最大値 */
  static readonly WARNING_THRESHOLDS_MIN_ALLOWED_MAX_VALUE = -1;
  /** 庫内温度と設定温度の温度差の警戒レベルを判定するための境界の最大値が許容する最小値 */
  static readonly WARNING_THRESHOLDS_MAX_ALLOWED_MIN_VALUE = 1;
  /** スケジュール標準設定（日毎の設定）に登録できる最大数 */
  static readonly SCHEDULE_DEFAULT_DAY_MAX = 20;
  /** 当日スケジュール，特定日スケジュールに登録できる最大数 */
  static readonly MAX_NUM_SETTING_SCHEDULE = 16;

  /** 通信テストを行う時間(秒)*/
  static readonly COMMUNICATION_TEST_TIME = 600;

  /** 運転データ履歴の取得上限数 */
  static readonly OPERATION_HISTORY_REQUEST_MAX = 10;
}

/**
 * プルダウンメニュー関連
 * 各項目の'label'プロパティについて、翻訳を要するものは翻訳用の名称にしている
 */
export class pullDownMenu {
  /** 地上階の選択項目 */
  static readonly ABOVEGROUND_FLOOR: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '0', label: 'groundFloor'},
    {value: '1', label: 'floor1'},
    {value: '2', label: 'floor2'},
    {value: '3', label: 'floor3'},
    {value: '4', label: 'floor4'},
    {value: '5', label: 'floor5'},
    {value: '6', label: 'floor6'},
    {value: '7', label: 'floor7'},
    {value: '8', label: 'floor8'},
    {value: '9', label: 'floor9'},
    {value: '10', label: 'floor10'},
    {value: '11', label: 'floor11'},
    {value: '12', label: 'floor12'},
    {value: '13', label: 'floor13'},
    {value: '14', label: 'floor14'},
  ];
  /** 地下階の選択項目 */
  static readonly UNDERGROUND_FLOOR: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '0', label: '-'}, //地下が無い場合
    {value: '-1', label: 'basement1'},
    {value: '-2', label: 'basement2'},
    {value: '-3', label: 'basement3'},
    {value: '-4', label: 'basement4'},
  ];
  /** インタフェースの種類の選択項目 */
  static readonly INTERFACE_TYPE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'SC-ADNA', label: 'scAdnaE'},
    {value: 'other', label: 'other'},
  ];
  /** 熱源機の種類の選択項目 */
  static readonly RT_UNIT_TYPE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'QtonClose', label: 'qton'},
    {value: 'Hyozan', label: 'hyozan'},
    {value: 'Chiller', label: 'chiller'},
  ];
  /** Q-tonの銘版の選択項目 */
  static readonly RT_UNIT_LABEL_QTON: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'ESA30E-25', label: 'esa30e25'},
    {value: 'ESA30EH-25', label: 'esa30eh25'},
    {value: 'ESA30EH2-25', label: 'esa30eh225'},
  ];
  /** Hyozanの銘版の選択項目 */
  static readonly RT_UNIT_LABEL_HYOZAN: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'HCCV1001E', label: 'hccv1001e'},
    {value: 'HCCV1001EA', label: 'hccv1001ea'},
    {value: 'HCCV2001E', label: 'hccv2001e'},
  ];
  /** Chillerの銘版の選択項目 */
  static readonly RT_UNIT_LABEL_CHILLER: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'MCUS5001VHE-W', label: 'mcus5001vhew'},
    {value: 'MCUS5001VHE-W1', label: 'mcus5001vhew1'},
    {value: 'MCUS5001VHE-W1A', label: 'mcus5001vhew1a'},
    {value: 'MCUS5001VHE-W2', label: 'mcus5001vhew2'},
    {value: 'MCUS5001VHE-W2A', label: 'mcus5001vhew2a'},
  ];
  /** Q-tonのユニットモデルの選択項目 */
  static readonly RT_UNIT_MODEL: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'WCMC', label: 'wcmc'},
    {value: 'WCMD', label: 'wcmd'},
    {value: 'WCME', label: 'wcme'},
  ];
  /** Q-tonのポンプモデルの選択項目 */
  static readonly RT_PUMP_MODEL: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'PD-51JU2', label: 'pd51ju2'},
    {value: 'PDC88-510C', label: 'pdc88510c'},
  ];
  /** タンクの表示設定の選択項目 */
  static readonly TANK_DISPLAY: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'display', label: 'display'},
    {value: 'noDisplay', label: 'hide'},
  ];
  /** 表示するタンクの番号の選択項目 */
  static readonly TANK_DISPLAY_NUMBER: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
    {value: '6', label: '6'},
    {value: '7', label: '7'},
    {value: '8', label: '8'},
    {value: '9', label: '9'},
  ];
  /** Qtonレポート発行月の選択項目(Qton)
   *  valueに配列を設定することが難しいためstringで代用している。
   *  APIに使用する場合はテーブルで配列に変換する
   */
  static readonly REPORT_ISSUE_THREE_MONTH: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '0', label: 'monthSet1'},
    {value: '1', label: 'monthSet2'},
    {value: '2', label: 'monthSet3'},
  ];
  /** 電気代通貨の選択項目 */
  static readonly ELECTRIC_CURRENCY: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'EUR', label: '€'},
    {value: 'GBP', label: '£'},
    {value: 'USD', label: '$'},
    {value: 'JPY', label: '¥'},
  ];
  /** 代替燃料の選択項目 */
  static readonly ALTERNATIVE_FUEL: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'heavy-oil', label: 'heavyOil'},
    {value: 'kerosene', label: 'kerosene'},
    {value: 'city-gas', label: 'cityGas'},
    {value: 'lpg', label: 'lpg'},
    {value: 'lng', label: 'lng'},
    {value: 'electric-heater', label: 'electricHeater'},
  ];
  /** 代替燃料単位の選択項目 */
  static readonly FUEL_UNIT_PRICE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'L', label: 'l'},
    {value: 'm3', label: 'm3'},
    {value: 'kWh', label: 'kWh'},
    {value: 'kg', label: 'kg'},
    {value: '1000000BTU', label: 'btu'},
  ];
  /** 冷媒(Chiller)の選択項目 */
  static readonly UNIT_REFRIGERANT: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'R410A', label: 'r410a'},
    {value: 'R32', label: 'r32'},
  ];
  /** Modbus用室外機の種類の選択項目 */
  static readonly MODBUS_OU_TYPE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [{value: 'HCCVQ', label: 'hccvq'}];
  /** 電源の種類の選択項目 */
  static readonly POWER_SUPPLY_TYPE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'threePhase', label: 'threePhase'},
    {value: 'singlePhase', label: 'singlePhase'},
  ];
  /** グループ切り替え時間の選択項目 */
  static readonly GROUP_CHANGE_TIME_FRAME: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '10', label: 'timeFrame1'},
    {value: '20', label: 'timeFrame2'},
    {value: '30', label: 'timeFrame3'},
    {value: '40', label: 'timeFrame4'},
    {value: '50', label: 'timeFrame5'},
    {value: '60', label: 'timeFrame6'},
  ];
  /** シングルビュー用状態値表示項目数の選択項目 */
  static readonly VIEW_ITEM_NUM_SINGLE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '3', label: 'tooltipSet3'},
    {value: '2', label: 'tooltipSet2'},
    {value: '1', label: 'tooltipSet1'},
  ];
  /** マルチビュー用状態値表示項目数の選択項目 */
  static readonly VIEW_ITEM_NUM_MULTI: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '3', label: 'tooltipSet3'},
    {value: '2', label: 'tooltipSet2'},
    {value: '1', label: 'tooltipSet1'},
  ];
  /** スケジュール用時刻の選択項目 */
  static readonly SCHEDULE_HOUR: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: '00', label: '00'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '05', label: '05'},
    {value: '06', label: '06'},
    {value: '07', label: '07'},
    {value: '08', label: '08'},
    {value: '09', label: '09'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
    {value: '13', label: '13'},
    {value: '14', label: '14'},
    {value: '15', label: '15'},
    {value: '16', label: '16'},
    {value: '17', label: '17'},
    {value: '18', label: '18'},
    {value: '19', label: '19'},
    {value: '20', label: '20'},
    {value: '21', label: '21'},
    {value: '22', label: '22'},
    {value: '23', label: '23'},
  ];
  /** スケジュール用時刻の選択項目 */
  static readonly SCHEDULE_MINUTE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: '00', label: '00'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '05', label: '05'},
    {value: '06', label: '06'},
    {value: '07', label: '07'},
    {value: '08', label: '08'},
    {value: '09', label: '09'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
    {value: '13', label: '13'},
    {value: '14', label: '14'},
    {value: '15', label: '15'},
    {value: '16', label: '16'},
    {value: '17', label: '17'},
    {value: '18', label: '18'},
    {value: '19', label: '19'},
    {value: '20', label: '20'},
    {value: '21', label: '21'},
    {value: '22', label: '22'},
    {value: '23', label: '23'},
    {value: '24', label: '24'},
    {value: '25', label: '25'},
    {value: '26', label: '26'},
    {value: '27', label: '27'},
    {value: '28', label: '28'},
    {value: '29', label: '29'},
    {value: '30', label: '30'},
    {value: '31', label: '31'},
    {value: '32', label: '32'},
    {value: '33', label: '33'},
    {value: '34', label: '34'},
    {value: '35', label: '35'},
    {value: '36', label: '36'},
    {value: '37', label: '37'},
    {value: '38', label: '38'},
    {value: '39', label: '39'},
    {value: '40', label: '40'},
    {value: '41', label: '41'},
    {value: '42', label: '42'},
    {value: '43', label: '43'},
    {value: '44', label: '44'},
    {value: '45', label: '45'},
    {value: '46', label: '46'},
    {value: '47', label: '47'},
    {value: '48', label: '48'},
    {value: '49', label: '49'},
    {value: '50', label: '50'},
    {value: '51', label: '51'},
    {value: '52', label: '52'},
    {value: '53', label: '53'},
    {value: '54', label: '54'},
    {value: '55', label: '55'},
    {value: '56', label: '56'},
    {value: '57', label: '57'},
    {value: '58', label: '58'},
    {value: '59', label: '59'},
  ];
  /** スケジュール用運転/停止の選択項目 */
  static readonly SCHEDULE_RUN_STOP: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: 'stop', label: 'stop'},
    {value: 'run', label: 'run'},
  ];
  /** スケジュール用運転モードの選択項目 */
  static readonly SCHEDULE_MODE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: 'auto', label: 'auto'},
    {value: 'dehumidify', label: 'dehumidify'},
    {value: 'cooling', label: 'cooling'},
    {value: 'fan', label: 'fan'},
    {value: 'heating', label: 'heating'},
  ];
  /** スケジュール用設定温度の選択項目 */
  static readonly SCHEDULE_SET_TEMP: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: '16', label: '16'},
    {value: '17', label: '17'},
    {value: '18', label: '18'},
    {value: '19', label: '19'},
    {value: '20', label: '20'},
    {value: '21', label: '21'},
    {value: '22', label: '22'},
    {value: '23', label: '23'},
    {value: '24', label: '24'},
    {value: '25', label: '25'},
    {value: '26', label: '26'},
    {value: '27', label: '27'},
    {value: '28', label: '28'},
    {value: '29', label: '29'},
    {value: '30', label: '30'},
  ];
  /** スケジュール用風量の選択項目 */
  static readonly SCHEDULE_FAN: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '--', label: '---'},
    {value: 'auto', label: 'auto'},
    {value: 'low', label: 'low'},
    {value: 'middle', label: 'middle'},
    {value: 'high', label: 'high'},
    {value: 'powerful', label: 'powerful'},
  ];
  /** スケジュール用特定日選択項目 */
  static readonly SCHEDULE_TEMPLATE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'weekday-schedule', label: 'weekday'},
    {value: 'holiday-schedule', label: 'holiday'},
    {value: 'special-day-1-schedule', label: 'specialDay1'},
    {value: 'special-day-2-schedule', label: 'specialDay2'},
  ];
  /** サイト一覧ソート方法の選択項目 */
  static readonly SITE_DISPLAY_ORDER: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'siteName', label: 'ascendingSiteName'},
    {value: '-siteName', label: 'descendingSiteName'},
    {value: '-registeredDate', label: 'newestDate'},
    {value: 'registeredDate', label: 'oldestDate'}, //default
  ];
  /** サイト一覧1ページ内の表示サイト数の選択項目 */
  static readonly SITE_DISPLAYED_IN_PAGE: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '5', label: '5'},
    {value: '10', label: '10'}, //default
    {value: '20', label: '20'},
  ];
  /** サイト一覧サイト権限フィルターの選択項目 */
  static readonly SITE_AUTHORITY_FILTER: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: 'unfiltered', label: '-'}, //default
    {value: 'admin', label: 'admin'},
    {value: 'manager', label: 'manager'},
    {value: 'viewer', label: 'viewer'},
  ];
  /** 庫内温度異常とするための閾値の選択項目 */
  static readonly ERROR_THRESHOLDS: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '0', label: 'errThreshold0'},
    {value: '1', label: 'errThreshold1'},
    {value: '2', label: 'errThreshold2'},
    {value: '3', label: 'errThreshold3'},
    {value: '4', label: 'errThreshold4'},
    {value: '5', label: 'errThreshold5'},
    {value: '6', label: 'errThreshold6'},
    {value: '7', label: 'errThreshold7'},
    {value: '8', label: 'errThreshold8'},
    {value: '9', label: 'errThreshold9'},
    {value: '10', label: 'errThreshold10'},
  ];
  /** 室内機のデマンド制御の温度シフトの選択項目 */
  static readonly DEMAND_SHIFT_TEMP: ReadonlyArray<{
    value: string;
    label: string;
  }> = [
    {value: '1', label: '1'},
    {value: '2', label: '2'},
    {value: '3', label: '3'},
    {value: '4', label: '4'},
    {value: '5', label: '5'},
    {value: '6', label: '6'},
    {value: '7', label: '7'},
    {value: '8', label: '8'},
    {value: '9', label: '9'},
    {value: '10', label: '10'},
  ];
  /** ロジック設定用テンプレートの選択項目 */
  static readonly LOGIC_TEMPLATE: {
    value: string;
    label: string;
  }[] = [
    {value: 'nop', label: 'None'},
    {value: 'warm-up-control', label: 'warmUpControl'},
    {value: 'cool-down-control', label: 'coolDownControl'},
    {value: 'high-temperature-alert', label: 'highTemperatureAlert'},
  ];
  /** ロジック設定用制御範囲の選択項目 */
  static readonly LOGIC_SCOPE: {
    value: string;
    label: string;
  }[] = [
    {value: 'site', label: 'allUnit'},
    {value: 'floor', label: 'floor'},
    {value: 'group', label: 'group'},
    {value: 'sl', label: 'unit'},
  ];
  /** ロジック設定用トリガーの選択項目 */
  static readonly LOGIC_TRIGGER: {
    value: string;
    label: string;
  }[] = [
    {value: 'indoor-temperature', label: 'roomTemp'},
    {value: 'outdoor-temperature', label: 'outdoorTemp'},
  ];
  /** ロジック設定用トリガー範囲の選択項目 */
  static readonly LOGIC_RANGE: {
    value: string;
    label: string;
  }[] = [
    {value: 'or-more', label: 'orMore'},
    {value: 'or-less', label: 'orLess'},
  ];
  /** ロジック設定用動作種別の選択項目 */
  static readonly LOGIC_ACTION: {
    value: string;
    label: string;
  }[] = [
    {value: 'control', label: 'control'},
    {value: 'notification', label: 'notification'},
  ];
  /** ロジック設定用運転モードの選択項目 */
  static readonly LOGIC_MODE: {
    value: string;
    label: string;
  }[] = [
    {value: '', label: ''},
    {value: 'auto', label: 'auto'},
    {value: 'cooling', label: 'cooling'},
    {value: 'heating', label: 'heating'},
    {value: 'fan', label: 'fan'},
    {value: 'dehumidify', label: 'dry'},
  ];
  /** ロジック設定用設定温度の選択項目（暖房モード） */
  static readonly LOGIC_SET_TEMP_HEATING: {
    value: string;
    label: string;
  }[] = [
    {value: '', label: ''},
    {value: '16.0', label: '16.0'},
    {value: '16.5', label: '16.5'},
    {value: '17.0', label: '17.0'},
    {value: '17.5', label: '17.5'},
    {value: '18.0', label: '18.0'},
    {value: '18.5', label: '18.5'},
    {value: '19.0', label: '19.0'},
    {value: '19.5', label: '19.5'},
    {value: '20.0', label: '20.0'},
    {value: '20.5', label: '20.5'},
    {value: '21.0', label: '21.0'},
    {value: '21.5', label: '21.5'},
    {value: '22.0', label: '22.0'},
    {value: '22.5', label: '22.5'},
    {value: '23.0', label: '23.0'},
    {value: '23.5', label: '23.5'},
    {value: '24.0', label: '24.0'},
    {value: '24.5', label: '24.5'},
    {value: '25.0', label: '25.0'},
    {value: '25.5', label: '25.5'},
    {value: '26.0', label: '26.0'},
    {value: '26.5', label: '26.5'},
    {value: '27.0', label: '27.0'},
    {value: '27.5', label: '27.5'},
    {value: '28.0', label: '28.0'},
    {value: '28.5', label: '28.5'},
    {value: '29.0', label: '29.0'},
    {value: '29.5', label: '29.5'},
    {value: '30.0', label: '30.0'},
  ];
  /** ロジック設定用設定温度の選択項目（暖房モード以外） */
  static readonly LOGIC_SET_TEMP: {
    value: string;
    label: string;
  }[] = [
    {value: '', label: ''},
    {value: '18.0', label: '18.0'},
    {value: '18.5', label: '18.5'},
    {value: '19.0', label: '19.0'},
    {value: '19.5', label: '19.5'},
    {value: '20.0', label: '20.0'},
    {value: '20.5', label: '20.5'},
    {value: '21.0', label: '21.0'},
    {value: '21.5', label: '21.5'},
    {value: '22.0', label: '22.0'},
    {value: '22.5', label: '22.5'},
    {value: '23.0', label: '23.0'},
    {value: '23.5', label: '23.5'},
    {value: '24.0', label: '24.0'},
    {value: '24.5', label: '24.5'},
    {value: '25.0', label: '25.0'},
    {value: '25.5', label: '25.5'},
    {value: '26.0', label: '26.0'},
    {value: '26.5', label: '26.5'},
    {value: '27.0', label: '27.0'},
    {value: '27.5', label: '27.5'},
    {value: '28.0', label: '28.0'},
    {value: '28.5', label: '28.5'},
    {value: '29.0', label: '29.0'},
    {value: '29.5', label: '29.5'},
    {value: '30.0', label: '30.0'},
  ];
  /** ロジック設定用風量の選択項目 */
  static readonly LOGIC_FAN: {
    value: string;
    label: string;
  }[] = [
    {value: '', label: ''},
    {value: 'auto', label: 'auto'},
    {value: 'low', label: 'low'},
    {value: 'middle', label: 'medium'},
    {value: 'high', label: 'high'},
    {value: 'powerful', label: 'powerful'},
  ];
  /** 言語設定の選択項目 */
  static readonly LANGUAGE_SETTINGS: {
    value: string;
    label: string;
  }[] = [
    {value: 'english', label: 'english'},
    {value: 'dutch', label: 'dutch'},
    {value: 'french', label: 'french'},
    {value: 'german', label: 'german'},
    {value: 'italian', label: 'italian'},
    {value: 'spanish', label: 'spanish'},
    {value: 'greek', label: 'greek'},
    {value: 'polish', label: 'polish'},
    {value: 'portuguese', label: 'portuguese'},
    {value: 'turkish', label: 'turkish'},
    {value: 'custom', label: 'custom'},
  ];
  /** スケジュール標準設定の特別日の月選択項目 */
  static readonly MONTH_OF_DAY_SETTING: {
    value: string;
    label: string;
  }[] = [
    {value: '01', label: 'january'},
    {value: '02', label: 'february'},
    {value: '03', label: 'march'},
    {value: '04', label: 'april'},
    {value: '05', label: 'may'},
    {value: '06', label: 'june'},
    {value: '07', label: 'july'},
    {value: '08', label: 'august'},
    {value: '09', label: 'september'},
    {value: '10', label: 'october'},
    {value: '11', label: 'november'},
    {value: '12', label: 'december'},
  ];
  /**  スケジュール標準設定の特別週間の週数選択項目 5週+LAST */
  static readonly WEEK_OF_WEEK_SETTING: {
    value: string;
    label: string;
  }[] = [
    {value: 'first', label: 'first'},
    {value: 'second', label: 'second'},
    {value: 'third', label: 'third'},
    {value: 'fourth', label: 'fourth'},
    {value: 'fifth', label: 'fifth'},
    {value: 'last', label: 'last'},
  ];
  /** スケジュール標準設定の特別週間の曜日選択項目 */
  static readonly DAY_OF_WEEK_SETTING: {
    value: string;
    label: string;
  }[] = [
    {value: 'monday', label: 'monday'},
    {value: 'tuesday', label: 'tuesday'},
    {value: 'wednesday', label: 'wednesday'},
    {value: 'thursday', label: 'thursday'},
    {value: 'friday', label: 'friday'},
    {value: 'saturday', label: 'saturday'},
    {value: 'sunday', label: 'sunday'},
  ];
  /** スケジュール標準設定の特別週間の月選項目 */
  static readonly MONTH_OF_WEEK_SETTING: {
    value: string;
    label: string;
  }[] = [
    {value: 'january', label: 'january'},
    {value: 'february', label: 'february'},
    {value: 'march', label: 'march'},
    {value: 'april', label: 'april'},
    {value: 'may', label: 'may'},
    {value: 'june', label: 'june'},
    {value: 'july', label: 'july'},
    {value: 'august', label: 'august'},
    {value: 'september', label: 'september'},
    {value: 'october', label: 'october'},
    {value: 'november', label: 'november'},
    {value: 'december', label: 'december'},
  ];
  /** スケジュール標準設定の特定日タイプ選択項目 */
  static readonly DAY_TYPE_SETTING: {
    value: string;
    label: string;
  }[] = [
    {value: 'weekday', label: 'weekday'},
    {value: 'holiday', label: 'holiday'},
    {value: 'special-day-1', label: 'specialDay1'},
    {value: 'special-day-2', label: 'specialDay2'},
  ];
  /** ヒストリー画面ユニットカテゴリーの選択項目 */
  static readonly HISTORY_CATEGORY: {
    value: string;
    label: string;
  }[] = [
    {value: '--', label: '---'},
    {
      value: 'airConditioner',
      label: 'airConditioner',
    },
    {value: 'qton', label: 'qton'},
    {value: 'hccvq', label: 'hccvq'},
    {
      value: 'chiller',
      label: 'chiller',
    },
  ];
  /** ヒストリー画面フィルターの選択項目*/
  static readonly HISTORY_FILTER: {
    value: string;
    label: string;
  }[] = [
    {value: '--', label: '---'},
    {
      value: 'indoorUnit',
      label: 'indoorUnit',
    },
    {
      value: 'outdoorUnit',
      label: 'outdoorUnit',
    },
  ];
  /** サイトグラフ 通信の種類 */
  static readonly SITE_GRAPH_MODE: {
    value: string;
    label: string;
  }[] = [
    {value: 'Aggregation', label: 'aggregation'},
    {value: 'Individual', label: 'individual'},
  ];
  /** 棒グラフ データ表示期間 */
  static readonly GRAPH_RANGE: {
    value: string;
    label: string;
  }[] = [
    {value: 'day', label: 'day'},
    {value: 'week', label: 'week'},
    {value: 'month', label: 'month'},
    {value: 'year', label: 'year'},
    {value: 'tenYear', label: 'tenYear'},
  ];
  /** 折れ線グラフ データ表示期間 */
  static readonly LINE_GRAPH_RANGE: {
    value: string;
    label: string;
  }[] = [
    {value: 'day', label: 'day'},
    {value: 'week', label: 'week'},
  ];
  /** ユーザ所属国一覧 */
  static readonly USER_COUNTRY_OF_INCORPORATION: {
    value: string;
    label: string;
  }[] = [
    {value: 'uk', label: 'uk'},
    {value: 'italy', label: 'italy'},
    {value: 'estonia', label: 'estonia'},
    {value: 'netherlands', label: 'netherlands'},
    {value: 'cyprus', label: 'cyprus'},
    {value: 'greece', label: 'greece'},
    {value: 'croatia', label: 'croatia'},
    {value: 'sweden', label: 'sweden'},
    {value: 'spain', label: 'spain'},
    {value: 'denmark', label: 'denmark'},
    {value: 'germany', label: 'germany'},
    {value: 'norway', label: 'norway'},
    {value: 'hungary', label: 'hungary'},
    {value: 'finland', label: 'finland'},
    {value: 'france', label: 'france'},
    {value: 'bulgaria', label: 'bulgaria'},
    {value: 'belgium', label: 'belgium'},
    {value: 'poland', label: 'poland'},
    {value: 'portugal', label: 'portugal'},
    {value: 'lithuania', label: 'lithuania'},
    {value: 'romania', label: 'romania'},
    {value: 'ireland', label: 'ireland'},
    {value: 'austria', label: 'austria'},
    {value: 'switzerland', label: 'switzerland'},
    {value: 'slovakia', label: 'slovakia'},
    {value: 'slovenia', label: 'slovenia'},
    {value: 'czechRepublic', label: 'czechRepublic'},
    {value: 'malta', label: 'malta'},
    {value: 'latvia', label: 'latvia'},
    {value: 'liechtenstein', label: 'liechtenstein'},
    {value: 'luxembourg', label: 'luxembourg'},
  ];
  /** 課金画面 VAT番号用国設定 */
  static readonly VAT_NUMBER_FORMAT: {
    value: apiIF.reqParameters.postBillingSettingTaxID['vat-format'];
    label: string;
  }[] = [
    {value: 'be_vat', label: 'beVAT'},
    {value: 'bg_uic', label: 'bgUIC'},
    {value: 'bg_vat', label: 'bgVAT'},
    {value: 'cy_vat', label: 'cyVAT'},
    {value: 'de_stn', label: 'deSTN'},
    {value: 'de_vat', label: 'deVAT'},
    {value: 'dk_vat', label: 'dkVAT'},
    {value: 'ee_vat', label: 'eeVAT'},
    {value: 'es_cif', label: 'esCIF'},
    {value: 'es_vat', label: 'esVAT'},
    {value: 'fi_vat', label: 'fiVAT'},
    {value: 'fr_vat', label: 'frVAT'},
    {value: 'gb_vat', label: 'gbVAT'},
    {value: 'gr_vat', label: 'grVAT'},
    {value: 'hr_vat', label: 'hrVAT'},
    {value: 'hu_tin', label: 'huTIN'},
    {value: 'hu_vat', label: 'huVAT'},
    {value: 'it_vat', label: 'itVAT'},
    {value: 'lt_vat', label: 'ltVAT'},
    {value: 'nl_vat', label: 'nlVAT'},
    {value: 'no_vat', label: 'noVAT'},
    {value: 'no_voec', label: 'noVOEC'},
    {value: 'pl_vat', label: 'plVAT'},
    {value: 'pt_vat', label: 'ptVAT'},
    {value: 'ro_tin', label: 'roTIN'},
    {value: 'ro_vat', label: 'roVAT'},
    {value: 'se_vat', label: 'seVAT'},
    {value: 'xi_vat', label: 'xiVAT'},
    {value: 'ie_vat', label: 'ieVAT'},
    {value: 'at_vat', label: 'atVAT'},
    {value: 'ch_uid', label: 'chUID'},
    {value: 'ch_vat', label: 'chVAT'},
    {value: 'sk_vat', label: 'skVAT'},
    {value: 'si_tin', label: 'siTIN'},
    {value: 'si_vat', label: 'siVAT'},
    {value: 'cz_vat', label: 'czVAT'},
    {value: 'mt_vat', label: 'mtVAT'},
    {value: 'lv_vat', label: 'lvVAT'},
    {value: 'li_uid', label: 'liUID'},
    {value: 'lu_vat', label: 'luVAT'},
  ];
}

/**
 * スライダーのマーカー関連
 */
export class sliderMarks {
  /** 庫内温度と設定温度の温度差の警戒レベルを判定するための境界 */
  static readonly WARNING_THRESHOLDS: Array<{
    value: number;
    label: React.ReactNode;
  }> = [
    {value: -5, label: '-5'},
    {value: 0, label: '0'},
    {value: 5, label: '5'},
  ];
  /** ロジック設定用閾値の下限値と上限値 */
  static readonly LOGIC_THRESHOLDS: {
    value: number;
    label: React.ReactNode;
  }[] = [
    {value: -20, label: '-20°C'},
    {value: 15, label: '15°C'},
    {value: 50, label: '50°C'},
  ];
  /** ロジック設定用設定温度(暖房モード)の下限値と上限値 */
  static readonly LOGIC_HEATING_SET_TEMP: {
    value: number;
    label: React.ReactNode;
  }[] = [
    {value: 16, label: '16°C'},
    {value: 24, label: '24,0°C'},
    {value: 30, label: '30°C'},
  ];
  /** ロジック設定用設定温度(暖房モード以外)の下限値と上限値 */
  static readonly LOGIC_SET_TEMP: {
    value: number;
    label: React.ReactNode;
  }[] = [
    {value: 18, label: '18°C'},
    {value: 24, label: '24,0°C'},
    {value: 30, label: '30°C'},
  ];
  /** スケジュール設定用設定温度(暖房モード)の下限値と上限値 */
  static readonly SCHEDULE_HEATING_SET_TEMP: {
    value: number;
    label: React.ReactNode;
  }[] = [
    {value: 16, label: '16°C'},
    {value: 24, label: '24,0°C'},
    {value: 30, label: '30°C'},
  ];
  /** スケジュール設定用設定温度(暖房モード以外)の下限値と上限値 */
  static readonly SCHEDULE_SET_TEMP: {
    value: number;
    label: React.ReactNode;
  }[] = [
    {value: 18, label: '18°C'},
    {value: 24, label: '24,0°C'},
    {value: 30, label: '30°C'},
  ];
}

/**
 * グラフ関連
 */
export class graph {
  /** 1日表示の折れ線グラフのデータプロット間隔 */
  static readonly DAY_LINE_DATE_RANGE = 5;
  /** 1週間表示の折れ線グラフのデータプロット間隔 */
  static readonly WEEK_LINE_DATE_RANGE = 30;
  /** 1日表示のバーグラフのデータプロット間隔 */
  static readonly DAY_BAR_DATE_RANGE = 60;
  /** 1週間表示のバーグラフのデータプロット間隔 */
  static readonly WEEK_BAR_DATE_RANGE = 1440;
  /** 1カ月表示のバーグラフのデータプロット間隔 */
  static readonly MONTH_BAR_DATE_RANGE = 1440;
  /** 1年表示のバーグラフのデータプロット間隔 */
  static readonly YEAR_BAR_DATE_RANGE = 44640;
  /** 10年表示のバーグラフのデータプロット間隔 */
  static readonly TEN_YEAR_BAR_DATE_RANGE = 525600;

  /** 1日表示の折れ線グラフのAPIデータ取得数 */
  static readonly DAY_LINE_API_MAX_RESULT =
    (60 * 24) / graph.DAY_LINE_DATE_RANGE;
  /** 1週間表示の折れ線グラフのデータプロット間隔 */
  static readonly WEEK_LINE_API_MAX_RESULT =
    (60 * 24 * 7) / graph.WEEK_LINE_DATE_RANGE;
  /** 1日表示のバーグラフのデータプロット間隔 */
  static readonly DAY_BAR_API_MAX_RESULT = (60 * 24) / graph.DAY_BAR_DATE_RANGE;
  /** 1週間表示のバーグラフのデータプロット間隔 */
  static readonly WEEK_BAR_API_MAX_RESULT =
    (60 * 24 * 7) / graph.WEEK_BAR_DATE_RANGE;
  /** 1か月表示のバーグラフのデータプロット間隔 */
  static readonly MONTH_BAR_API_MAX_RESULT =
    (60 * 24 * 31) / graph.MONTH_BAR_DATE_RANGE;
  /** 1年表示のバーグラフのデータプロット間隔 */
  static readonly YEAR_BAR_API_MAX_RESULT =
    (60 * 24 * 31 * 12) / graph.YEAR_BAR_DATE_RANGE;
  /** 10年表示のバーグラフのデータプロット間隔 */
  static readonly TEN_YEAR_BAR_API_MAX_RESULT =
    (60 * 24 * 31 * 12 * 10) / graph.TEN_YEAR_BAR_DATE_RANGE;

  /** 温度グラフの1日表示時のデータ取得間隔(msec) */
  static readonly TREND_REPORTING_EVERY_MSEC_DAY =
    60000 * graph.DAY_LINE_DATE_RANGE;
  /** 温度グラフの1週間表示のデータ取得間隔(msec) */
  static readonly TREND_REPORTING_EVERY_MSEC_WEEK =
    60000 * graph.WEEK_LINE_DATE_RANGE;

  /** グラフアイテムの選択可能上限数 */
  static readonly ITEM_MAX_NUMBER = 4;
  /** 比較グラフアイテムの選択可能上限数 */
  static readonly COMPARISON_ITEM_MAX_NUMBER = 3;

  /**
   * グラフで使用する色
   */
  /** Heat */
  static readonly GRAPH_COLOR_HEAT = '#f05115';
  /** Cool */
  static readonly GRAPH_COLOR_COOL = '#103fb4';
  /** Pansy */
  static readonly GRAPH_COLOR_PANSY = '#2e294e';
  /** Light Heat */
  static readonly GRAPH_COLOR_LIGHT_HEAT = '#ff9999';
  /** Light Cool */
  static readonly GRAPH_COLOR_LIGHT_COOL = '#99ccff';
  /** Light Pansy */
  static readonly GRAPH_COLOR_LIGHT_PANSY = '#9999ff';
  /** Gold */
  static readonly GRAPH_COLOR_GOLD = '#f0c015';
  /** Cyan */
  static readonly GRAPH_COLOR_CYAN = '#06e1fd';
  /** Plum */
  static readonly GRAPH_COLOR_PLUM = '#700054';
  /** Tomato */
  static readonly GRAPH_COLOR_TOMATO = '#e8794e';
  /** Light Plum */
  static readonly GRAPH_COLOR_LIGHT_PLUM = '#DE00A4';
  /** Light Gold */
  static readonly GRAPH_COLOR_LIGHT_GOLD = '#b21200';
  /** Light Cyan */
  static readonly GRAPH_COLOR_LIGHT_CYAN = '#e0ffff';
}

/**
 * ロジック関連
 */
export class logic {
  /** 閾値の最低値 */
  static readonly THRESHOLD_MIN = -20;
  /** 閾値の最高値 */
  static readonly THRESHOLD_MAX = 50;
  /** 設定温度の最低値（暖房モード以外） */
  static readonly SET_TEMP_MIN = 18;
  /** 設定温度の最低値（暖房モード） */
  static readonly SET_TEMP_HEATING_MIN = 16;
  /** 設定温度の最高値 */
  static readonly SET_TEMP_MAX = 30;
}

/**
 * スケジュール関連
 */
export class scheduleTemp {
  /** 設定温度の最低値（暖房モード以外） */
  static readonly SET_TEMP_MIN = 18;
  /** 設定温度の最低値（暖房モード） */
  static readonly SET_TEMP_HEATING_MIN = 16;
  /** 設定温度の最高値 */
  static readonly SET_TEMP_MAX = 30;
}

export class billing {
  /** VAT番号のフォーマット別プレースホルダ */
  static readonly vatPlaceholderTable = {
    '': '',
    'be_vat': 'BE0123456789',
    'bg_uic': '123456789',
    'bg_vat': 'BG0123456789',
    'cy_vat': 'CY12345678Z',
    'de_stn': '1234567890',
    'de_vat': 'DE123456789',
    'dk_vat': 'DK12345678',
    'ee_vat': 'EE123456789',
    'es_cif': 'A12345678',
    'es_vat': 'ESA1234567Z',
    'fi_vat': 'FI12345678',
    'fr_vat': 'FRAB123456789',
    'gb_vat': 'GB123456789',
    'gr_vat': 'EL123456789',
    'hr_vat': 'HR12345678912',
    'hu_tin': '12345678-1-23',
    'hu_vat': 'HU12345678',
    'it_vat': 'IT12345678912',
    'lt_vat': 'LT123456789123',
    'nl_vat': 'NL123456789B12',
    'no_vat': '123456789MVA',
    'no_voec': '1234567',
    'pl_vat': 'PL1234567890',
    'pt_vat': 'PT123456789',
    'ro_tin': '1234567890123',
    'ro_vat': 'RO1234567891',
    'se_vat': 'SE123456789123',
    'xi_vat': 'XI123456789',
    'ie_vat': 'IE1234567AB',
    'at_vat': 'ATU12345678',
    'ch_uid': 'CHE-123.456.789 HR',
    'ch_vat': 'CHE-123.456.789 MWST',
    'sk_vat': 'SK1234567891',
    'si_tin': '12345678',
    'si_vat': 'SI12345678',
    'cz_vat': 'CZ1234567890',
    'mt_vat': 'MT12345678',
    'lv_vat': 'LV12345678912',
    'li_uid': 'CHE123456789',
    'lu_vat': 'LU12345678',
  };
}

//prettier-ignore
/**
 * 色関連
 */
export class color {
  static readonly OBJECT_BASE_MHI_RED     = '#e31f26';
  static readonly OBJECT_BASE_PURE_BLACK  = '#000000';
}

/** ファイル関連 */
export class file {
  /** ロゴ画像が保存されているS3のキープレフィックス */
  static readonly LOGO_S3_KEY_PREFIX = 'logo/';
  /** 言語ファイルが保存されているS3のキープレフィックス */
  static readonly LANGUAGE_S3_KEY_PREFIX = 'language/';
  /** カスタム言語テンプレートファイル名 */
  static readonly CUSTOM_LANGUAGE_NAME = 'custom-language.csv';
  /** M-ACCESSロゴの画像名 */
  static readonly MACCESS_LOGO_NAME = 'M-ACCESS.png';
  /** M-ACCESSロゴのデフォルト画像パス */
  static readonly MACCESS_LOGO_PATH = `${process.env.PUBLIC_URL}/img/mysite/branding/m-access-logo.png`;
  /** MITSUBISHIロゴの画像名 */
  static readonly MHI_LOGO_NAME = 'MHI.png';
  /** MITSUBISHIロゴのデフォルト画像パス */
  static readonly MHI_LOGO_PATH = `${process.env.PUBLIC_URL}/img/mysite/branding/mhi-logo.svg`;
  /** ユーザ設定言語のファイル名 */
  static readonly CUSTOM_TRANSLATION_NAME = 'customTranslation.csv';
  /** 言語ファイルが保存されているS3のキープレフィックス */
  static readonly PUBLIC_DOCUMENT_S3_KEY_PREFIX = 'public-document/';
}

/**
 * アイコン（黒色）関連
 * 各項目の'alt','title'プロパティについて、翻訳を要するものは翻訳用の名称にしている
 */
export class iconBlack {
  //Navigation
  static readonly SETTINGS = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/settings.svg`,
    alt: 'settings',
    title: 'settings',
  };
  static readonly USER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/user.svg`,
    alt: 'user',
    title: 'User',
  };
  static readonly LEGEND = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/legend.svg`,
    alt: 'legend',
    title: 'Legend',
  };
  static readonly CHEVRON_LEFT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-left.svg`,
    alt: 'Chevron left',
    title: 'Chevron left',
  };
  static readonly CHEVRON_RIGHT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-right.svg`,
    alt: 'chevronRight',
    title: 'Chevron right',
  };
  static readonly CHEVRON_UP = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-right.svg`,
    alt: 'Chevron up',
    title: 'Chevron up',
  };
  static readonly CHEVRON_DOWN = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-down.svg`,
    alt: 'chevronDown',
    title: 'Chevron down',
  };
  static readonly DOUBLE_CHEVRON_LEFT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/double-chevron-left.svg`,
    alt: 'Double Chevron left',
    title: 'Double Chevron left',
  };
  static readonly DOUBLE_CHEVRON_RIGHT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/double-chevron-right.svg`,
    alt: 'Double Chevron right',
    title: 'Double Chevron right',
  };
  static readonly POP_OUT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/popout.svg`,
    alt: 'popout',
    title: 'popout',
  };
  static readonly FULL_SIZE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/full-size.svg`,
    alt: 'Full-size',
    title: 'Full-size',
  };
  static readonly ARROW_LEFT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/back.svg`,
    alt: 'Arrow left',
    title: 'Arrow left',
  };
  static readonly ARROW_RIGHT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/next.svg`,
    alt: 'Arrow right',
    title: 'Arrow right',
  };
  static readonly ARROW_UP = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/up.svg`,
    alt: 'arrowUp',
    title: 'Arrow up',
  };
  static readonly ARROW_DOWN = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/down.svg`,
    alt: 'arrowDown',
    title: 'Arrow down',
  };
  static readonly CLOSE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/close.svg`,
    alt: 'Close',
    title: 'Close',
  };
  static readonly SITE_DETAILS = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/details.svg`,
    alt: 'siteDetails',
    title: 'Site details',
  };
  static readonly FILTER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/filter.svg`,
    alt: 'filter',
    title: 'filter',
  };
  //Functions
  static readonly CONTROLLER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/ac-controller.svg`,
    alt: 'controller',
    title: 'controller',
  };
  static readonly BAR_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/bar-graph.svg`,
    alt: 'barGraph',
    title: 'barGraph',
  };
  static readonly LINE_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/line-chart.svg`,
    alt: 'lineGraph',
    title: 'lineGraph',
  };
  static readonly UPLOAD = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/upload.svg`,
    alt: 'upload',
    title: 'Upload',
  };
  static readonly DOWNLOAD = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/download.svg`,
    alt: 'download',
    title: 'Download',
  };
  static readonly EDIT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/edit.svg`,
    alt: 'edit',
    title: 'edit',
  };
  static readonly DELETE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/delete.svg`,
    alt: 'delete',
    title: 'Delete',
  };
  static readonly POWER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/power.svg`,
    alt: 'stop',
    title: 'stop',
  };
  static readonly ADD_SITE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/add-site.svg`,
    alt: 'addSite',
    title: 'Add site',
  };
  static readonly RETRY = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/reset.svg`,
    alt: 'retry',
    title: 'Retry',
  };
  static readonly PLAYER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/player.svg`,
    alt: 'Player',
    title: 'Player',
  };
  static readonly MULTI_VIEW = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/multiview.svg`,
    alt: 'Multi view',
    title: 'Multi view',
  };
  //Indicators
  static readonly AC_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ac-on.svg`,
    alt: 'acOn',
    title: 'AC on',
  };
  static readonly AC_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ac-off.svg`,
    alt: 'acOff',
    title: 'AC off',
  };
  static readonly FDT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdt-unit-on.svg`,
    alt: 'fdtOn',
    title: 'FDT on',
  };
  static readonly FDT_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdt-unit-off.svg`,
    alt: 'fdtOff',
    title: 'FDT off',
  };
  static readonly FDTS_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdts-unit-on.svg`,
    alt: 'fdtsOn',
    title: 'FDTS on',
  };
  static readonly FDTS_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdts-unit-off.svg`,
    alt: 'fdtsOff',
    title: 'FDTS off',
  };
  static readonly FDTW_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdtw-unit-on.svg`,
    alt: 'fdtwOn',
    title: 'FDTW on',
  };
  static readonly FDTW_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdtw-unit-off.svg`,
    alt: 'fdtwOff',
    title: 'FDTW off',
  };
  static readonly FDE_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fde-unit-on.svg`,
    alt: 'fdeOn',
    title: 'FDE on',
  };
  static readonly FDE_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fde-unit-off.svg`,
    alt: 'fdeOff',
    title: 'FDE off',
  };
  static readonly FDF_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdf-unit-on.svg`,
    alt: 'fdfOn',
    title: 'FDF on',
  };
  static readonly FDF_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdf-unit-off.svg`,
    alt: 'fdfOff',
    title: 'FDF off',
  };
  static readonly FDFW_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdfw-unit-on.svg`,
    alt: 'fdfwOn',
    title: 'FDFW on',
  };
  static readonly FDFW_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdfw-unit-off.svg`,
    alt: 'fdfwOff',
    title: 'FDFW off',
  };
  static readonly FDK_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdk-unit-on.svg`,
    alt: 'fdkOn',
    title: 'FDK on',
  };
  static readonly FDK_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdk-unit-off.svg`,
    alt: 'fdkOff',
    title: 'FDK off',
  };
  static readonly FDU_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdu-unit-on.svg`,
    alt: 'fduOn',
    title: 'FDU on',
  };
  static readonly FDU_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdu-unit-off.svg`,
    alt: 'fduOff',
    title: 'FDU off',
  };
  static readonly VENTILATOR_UNIT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ventilator-unit-on.svg`,
    alt: 'ventilatorOn',
    title: 'Ventilator on',
  };
  static readonly VENTILATOR_UNIT_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ventilator-unit-off.svg`,
    alt: 'ventilatorOff',
    title: 'Ventilator off',
  };
  static readonly LIGHT_UNIT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/light-unit-on.svg`,
    alt: 'lightOn',
    title: 'Light on',
  };
  static readonly LIGHT_UNIT_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/light-unit-off.svg`,
    alt: 'lightOff',
    title: 'Light off',
  };
  static readonly FREEZER_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/freezer-on.svg`,
    alt: 'freezerOn',
    title: 'Freezer on',
  };
  static readonly FREEZER_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/freezer-off.svg`,
    alt: 'freezerOff',
    title: 'Freezer off',
  };
  static readonly HOT_WATER_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/water-on.svg`,
    alt: 'hotWaterOn',
    title: 'Hot water on',
  };
  static readonly HOT_WATER_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/water-off.svg`,
    alt: 'Hot water off',
    title: 'Hot water off',
  };
  static readonly ERROR = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/error.svg`,
    alt: 'error',
    title: 'Error',
  };
  static readonly SUCCESS = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/success.svg`,
    alt: 'success',
    title: 'Success',
  };
  static readonly FAILURE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/failure.svg`,
    alt: 'failure',
    title: 'Failure',
  };
  static readonly LINKED = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/linked.svg`,
    alt: 'linked',
    title: 'Linked',
  };
  static readonly HOT_WATER_RUNNING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/hot-water-running.svg`,
    alt: 'Hot water running',
    title: 'Hot water running',
  };
  static readonly HOT_WATER_PAUSED = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/hot-water-paused.svg`,
    alt: 'Hot water paused',
    title: 'Hot water paused',
  };
  static readonly HOT_WATER_STOPPED = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/hot-water-stopped.svg`,
    alt: 'Hot water stopped',
    title: 'Hot water stopped',
  };
  static readonly SET_TEMPERATURE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/temperature-set.svg`,
    alt: 'setTemp',
    title: 'Set temperature',
  };
  static readonly ACTUAL_TEMPERATURE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/temperature-actual.svg`,
    alt: 'Actual temperature',
    title: 'Actual temperature',
  };
  //Operation Mode Indicators
  static readonly AUTO = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-automatic.svg`,
    alt: 'auto',
    title: 'Auto',
  };
  static readonly COOLING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-cooling.svg`,
    alt: 'cooling',
    title: 'Cooling',
  };
  static readonly HEATING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-heating.svg`,
    alt: 'heating',
    title: 'Heating',
  };
  static readonly BLOWER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-blow.svg`,
    alt: 'blower',
    title: 'Blower',
  };
  static readonly DRYING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-dry.svg`,
    alt: 'drying',
    title: 'Drying',
  };
  //Fan Speed Indicators
  static readonly FAN_SPEED_AUTO = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-automatic.svg`,
    alt: 'fanSpeedAuto',
    title: 'Fan speed auto',
  };
  static readonly FAN_SPEED_1 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-1.svg`,
    alt: 'fanSpeed1',
    title: 'Fan speed 1',
  };
  static readonly FAN_SPEED_2 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-2.svg`,
    alt: 'fanSpeed2',
    title: 'Fan speed 2',
  };
  static readonly FAN_SPEED_3 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-3.svg`,
    alt: 'fanSpeed3',
    title: 'Fan speed 3',
  };
  static readonly FAN_SPEED_4 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-4.svg`,
    alt: 'fanSpeed4',
    title: 'Fan speed 4',
  };
  //other
  static readonly MISSING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/other/missing-icon.svg`,
    alt: 'missing',
    title: 'Missing',
  };
}
/**
 * アイコン（白色）関連
 * 各項目の'alt','title'プロパティについて、翻訳を要するものは翻訳用の名称にしている
 */
export class iconWhite {
  //Navigation
  static readonly CHEVRON_RIGHT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-right_w.svg`,
    alt: 'Chevron right',
    title: 'Chevron right',
  };
  static readonly CHEVRON_DOWN = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/chevron-down_w.svg`,
    alt: 'chevronDown',
    title: 'Chevron down',
  };
  static readonly FULL_SIZE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/full-size_w.svg`,
    alt: 'Full-size',
    title: 'Full-size',
  };
  static readonly ARROW_UP = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/up_w.svg`,
    alt: 'arrowUp',
    title: 'Arrow up',
  };
  static readonly CLOSE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/close_w.svg`,
    alt: 'close',
    title: 'close',
  };
  //Functions
  static readonly CONTROLLER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/ac-controller-w.svg`,
    alt: 'controller',
    title: 'controller',
  };
  static readonly BAR_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/bar-graph_w.svg`,
    alt: 'barGraph',
    title: 'barGraph',
  };
  static readonly LINE_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/line-chart_w.svg`,
    alt: 'lineGraph',
    title: 'Line graph',
  };
  static readonly EDIT = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/edit_w.svg`,
    alt: 'edit',
    title: 'edit',
  };
  static readonly DELETE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/delete_w.svg`,
    alt: 'delete',
    title: 'delete',
  };
  static readonly POWER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/power_w.svg`,
    alt: 'run',
    title: 'run',
  };
  //Indicators
  static readonly AC_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ac-on_w.svg`,
    alt: 'acOn',
    title: 'AC on',
  };
  static readonly AC_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ac-off_w.svg`,
    alt: 'acOff',
    title: 'AC off',
  };
  static readonly FDT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdt-unit-on_w.svg`,
    alt: 'fdtOn',
    title: 'FDT on',
  };
  static readonly FDTS_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdts-unit-on_w.svg`,
    alt: 'fdtsOn',
    title: 'FDTS on',
  };
  static readonly FDTW_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdtw-unit-on_w.svg`,
    alt: 'fdtwOn',
    title: 'FDTW on',
  };
  static readonly FDE_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fde-unit-on_w.svg`,
    alt: 'fdeOn',
    title: 'FDE on',
  };
  static readonly FDF_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdf-unit-on_w.svg`,
    alt: 'fdfOn',
    title: 'FDF on',
  };
  static readonly FDFW_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdfw-unit-on_w.svg`,
    alt: 'fdfwOn',
    title: 'FDFW on',
  };
  static readonly FDK_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdk-unit-on_w.svg`,
    alt: 'fdkOn',
    title: 'FDK on',
  };
  static readonly FDU_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fdu-unit-on_w.svg`,
    alt: 'fduOn',
    title: 'FDU on',
  };
  static readonly VENTILATOR_UNIT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ventilator-unit-on_w.svg`,
    alt: 'ventilatorOn',
    title: 'Ventilator on',
  };
  static readonly VENTILATOR_UNIT_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/ventilator-unit-off_w.svg`,
    alt: 'ventilatorOff',
    title: 'Ventilator off',
  };
  static readonly LIGHT_UNIT_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/light-unit-on_w.svg`,
    alt: 'lightOn',
    title: 'Light on',
  };
  static readonly LIGHT_UNIT_OFF = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/light-unit-off_w.svg`,
    alt: 'lightOff',
    title: 'Light off',
  };
  static readonly FREEZER_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/freezer-on_w.svg`,
    alt: 'freezerOn',
    title: 'Freezer on',
  };
  static readonly HOT_WATER_ON = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/water-on_w.svg`,
    alt: 'hotWaterOn',
    title: 'Hot water on',
  };
  static readonly ERROR = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/error_w.svg`,
    alt: 'error',
    title: 'Error',
  };
  static readonly ACTUAL_TEMPERATURE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/temperature-actual_w.svg`,
    alt: 'Actual temperature',
    title: 'Actual temperature',
  };
  //Operation Mode Indicators
  static readonly AUTO = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-automatic_w.svg`,
    alt: 'auto',
    title: 'Auto',
  };
  static readonly COOLING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-cooling_w.svg`,
    alt: 'cooling',
    title: 'Cooling',
  };
  static readonly HEATING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-heating_w.svg`,
    alt: 'heating',
    title: 'Heating',
  };
  static readonly BLOWER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-blow_w.svg`,
    alt: 'blower',
    title: 'Blower',
  };
  static readonly DRYING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/mode/om-dry_w.svg`,
    alt: 'drying',
    title: 'Drying',
  };
  //Fan Speed Indicators
  static readonly FAN_SPEED_AUTO = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-automatic_w.svg`,
    alt: 'fanSpeedAuto',
    title: 'Fan speed auto',
  };
  static readonly FAN_SPEED_1 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-1_w.svg`,
    alt: 'fanSpeed1',
    title: 'Fan speed 1',
  };
  static readonly FAN_SPEED_2 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-2_w.svg`,
    alt: 'fanSpeed2',
    title: 'Fan speed 2',
  };
  static readonly FAN_SPEED_3 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-3_w.svg`,
    alt: 'fanSpeed3',
    title: 'Fan speed 3',
  };
  static readonly FAN_SPEED_4 = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/fan/fan-speed-4_w.svg`,
    alt: 'fanSpeed4',
    title: 'Fan speed 4',
  };
  //other
  static readonly MISSING = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/other/missing-icon_w.svg`,
    alt: 'missing',
    title: 'Missing',
  };
}
/**
 * アイコン（赤色）関連
 * 各項目の'alt','title'プロパティについて、翻訳を要するものは翻訳用の名称にしている
 */
export class iconRed {
  //Navigation
  static readonly CLOSE = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/navigation/close_r.svg`,
    alt: 'close',
    title: 'Close',
  };
  //Functions
  static readonly BAR_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/bar-graph_r.svg`,
    alt: 'Bar graph',
    title: 'Bar graph',
  };
  static readonly LINE_GRAPH = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/line-chart_r.svg`,
    alt: 'Line graph',
    title: 'Line graph',
  };
  static readonly PLAYER = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/player_r.svg`,
    alt: 'Player',
    title: 'Player',
  };
  static readonly MULTI_VIEW = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/function/multiview_r.svg`,
    alt: 'Multi view',
    title: 'Multi view',
  };
  //Indicators
  //Operation Mode Indicators
  //Fan Speed Indicators
}
/**
 * アイコン（黄色）関連
 * 各項目の'alt','title'プロパティについて、翻訳を要するものは翻訳用の名称にしている
 */
export class iconYellow {
  //Navigation
  //Functions
  //Indicators
  static readonly ERROR = {
    src: `${process.env.PUBLIC_URL}/img/mysite/icon/indicator/error_y.svg`,
    alt: 'error',
    title: 'Error',
  };
  //Operation Mode Indicators
  //Fan Speed Indicators
}

/** 特別なID */
export class specialID {
  /** InteractJSによるドラッグ制御を無効化するID（ドラッグによる動作を正しく制御させるため） */
  static readonly IGNORE_INTERACTJS_ID = 'mv-ignoreInteractJS';
}

export default format;
